import { render } from "./ItemsWaiting.vue?vue&type=template&id=e35f04a8"
import script from "./ItemsWaiting.vue?vue&type=script&lang=js"
export * from "./ItemsWaiting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__